import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
// import "./style.css";
// import "./bootstrap.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { themes } from "./themes";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import store from "./redux/store";
import { CartProvider } from "./pages/BusinessToolMarketPlace/context/CartContext";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
    mutations: {
      refetchOnWindowFocus: false,
      retry: false,
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
});

const ThemedApp = () => {
  const [theme, setTheme] = useState("default");

  const applyTheme = (themeKey) => {
    setTheme(themeKey);
    window.localStorage.setItem("theme", themeKey);
  };

  useEffect(() => {
    const theme = window.localStorage.getItem("theme");
    if (theme) {
      setTheme(theme);
    }
  }, []);

  return (
    <ConfigProvider theme={themes[theme]}>
      <App applyTheme={applyTheme} theme={theme} />
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <CartProvider>
        <QueryClientProvider client={queryClient}>
          <ThemedApp />
        </QueryClientProvider>
      </CartProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
